var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var e_1, _a;
import erc20 from "./data/exchange/erc20";
import coins from "./data/exchange/coins";
import bep20 from "./data/exchange/bep20";
var all = __spreadArray(__spreadArray(__spreadArray([], __read(coins), false), __read(erc20), false), __read(bep20), false);
var configs = {};
try {
    for (var all_1 = __values(all), all_1_1 = all_1.next(); !all_1_1.done; all_1_1 = all_1.next()) {
        var _b = __read(all_1_1.value, 3), id = _b[0], config = _b[1], signature = _b[2];
        configs[id] = {
            config: config,
            signature: signature
        };
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (all_1_1 && !all_1_1.done && (_a = all_1["return"])) _a.call(all_1);
    }
    finally { if (e_1) throw e_1.error; }
}
/**
 *
 */
export var findExchangeCurrencyConfig = function (id) { return configs[id]; };
//# sourceMappingURL=exchange.js.map